import { lerp } from './number';
export const lerpColorRGBA = (value, inMin, inMax, color1, color2) => {
    const parse = (c) => {
        const hex = c.replace('#', '');
        const bigint = parseInt(hex, 16);
        return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
    };
    const [r1, g1, b1] = parse(color1);
    const [r2, g2, b2] = parse(color2);
    const r = Math.round(lerp(value, inMin, inMax, r1, r2));
    const g = Math.round(lerp(value, inMin, inMax, g1, g2));
    const b = Math.round(lerp(value, inMin, inMax, b1, b2));
    return `rgb(${r},${g},${b})`;
};
export const hexLighten = (hex, factor) => {
    const num = parseInt(hex.replace('#', ''), 16);
    let r = (num >> 16) + factor;
    let g = ((num >> 8) & 0x00ff) + factor;
    let b = (num & 0x0000ff) + factor;
    r = Math.min(255, Math.max(0, r));
    g = Math.min(255, Math.max(0, g));
    b = Math.min(255, Math.max(0, b));
    return `#${(b | (g << 8) | (r << 16)).toString(16).padStart(6, '0')}`;
};
